<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';

const props = defineProps<{
	class?: HTMLAttributes['class'];
}>();
</script>

<template>
	<div :class="cn('flex items-center px-9 pb-9 pt-0', props.class)">
		<slot></slot>
	</div>
</template>
